import VueCookies from 'vue-cookies';
import { USER_PRIVILEGE } from '@/utilsAuth';

export const ROLE_LEVEL = {
  ADMIN: 3,
  SUPPLIER: 2,
  CUSTOMER: 1
};


const env = process.env;

export const hasFeature = (key) => env[`VUE_APP_FEATURE_${key.toUpperCase()}`] === 'true';

/*export const isHaveRole = (role) => {
  const userPermission = VueCookies.get(USER_PRIVILEGE);
  return userPermission?.includes(role);
};*/

export const isHaveRole = (requiredRole) => {
  const rawRoles = VueCookies.get(USER_PRIVILEGE);
  const userRoles = normalizeRoles(rawRoles);

  const userMaxLevel = Math.max(
    ...userRoles.map(role => ROLE_LEVEL[role] || 0),
    0
  );

  const requiredLevel = ROLE_LEVEL[requiredRole] || 0;

  return userMaxLevel >= requiredLevel;
};


/* ---------- Helpers ---------- */
const normalizeRoles = (roles) => {
  if (!roles) return [];
  if (Array.isArray(roles)) return roles;
  if (typeof roles === 'string') {
    return roles.split(',').map(r => r.trim());
  }
  return [];
};


export const ROLES = {
  ADMIN: "admin",
  SUPPLIER: "supplier",
  ACCOUNTANT: "accountant",
  INVOICE: "invoice",
  QUOTE: "quote",
  REPORTING: "reporting",
  PURCHASE_INVOICE: "purchase_invoice",
  NOTIFICATION: "notification",
};


const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    ROLES.ADMIN,
    ROLES.SUPPLIER,
    ROLES.ACCOUNTANT,
    ROLES.INVOICE,
    ROLES.QUOTE,
    ROLES.REPORTING,
    ROLES.PURCHASE_INVOICE,
    ROLES.NOTIFICATION,
  ],

  [ROLES.SUPPLIER]: [
    ROLES.SUPPLIER,
    ROLES.ACCOUNTANT,
    ROLES.INVOICE,
    ROLES.QUOTE,
    ROLES.REPORTING,
    ROLES.PURCHASE_INVOICE,
    ROLES.NOTIFICATION,
  ],

  [ROLES.ACCOUNTANT]: [ROLES.ACCOUNTANT],
  [ROLES.INVOICE]: [ROLES.INVOICE],
  [ROLES.QUOTE]: [ROLES.QUOTE],
  [ROLES.REPORTING]: [ROLES.REPORTING],
  [ROLES.PURCHASE_INVOICE]: [ROLES.PURCHASE_INVOICE],
  [ROLES.NOTIFICATION]: [ROLES.NOTIFICATION],
};

export const hasRole = (requiredRole) => {

  const rawRoles = VueCookies.get(USER_PRIVILEGE);
  const userRoles = normalizeRoles(rawRoles);

  const roles = normalizeRoles(userRoles);
  const target = String(requiredRole || "").toLowerCase();

  return roles.some(role =>
    (ROLE_PERMISSIONS[role] || []).includes(target)
  );
};

export const hasExactRole = (requiredRole) => {
  const roles = normalizeRoles(VueCookies.get(USER_PRIVILEGE));
  const target = String(requiredRole || "").toLowerCase();
  return roles.some(role => String(role).toLowerCase() === target);
};

export const isAccountantOnly = () =>
  hasExactRole(ROLES.ACCOUNTANT) &&
  !hasExactRole(ROLES.SUPPLIER) &&
  !hasExactRole(ROLES.ADMIN);
